export type AuditEntityType =
  | 'RESULT'
  | 'COMPETITION'
  | 'TEAM'
  | 'CATEGORY'
  | 'DISCIPLINE'
  | 'RECORDER'
  | 'USER'
  | 'AUTH';

export type AuditAction =
  | 'CREATE'
  | 'UPDATE'
  | 'DELETE'
  | 'ASSIGN'
  | 'REVOKE'
  | 'LOGIN_SUCCESS'
  | 'LOGIN_FAIL'
  | 'LOGOUT'
  | 'PASSWORD_CHANGE'
  | 'PASSWORD_RESET';

export type AuditUserRole = 'SUPER_ADMIN' | 'UNIT_ADMIN' | 'RECORDER';

export interface AuditLogEntry {
  id: number;
  unitId: number | null;
  competitionId: number | null;
  entityType: AuditEntityType;
  entityId: number | null;
  action: AuditAction;
  changedFields: string[] | null;
  oldValues: Record<string, unknown> | null;
  newValues: Record<string, unknown> | null;
  summary: string | null;
  changedBy: number | null;
  changedByUsername: string | null;
  changedByRole: AuditUserRole | null;
  ipAddress: string | null;
  userAgent: string | null;
  changedAt: string;
}

export interface AuditPage {
  items: AuditLogEntry[];
  total: number;
  page: number;
  size: number;
}

export interface AuditFilter {
  unitId?: number;
  competitionId?: number;
  entityType?: AuditEntityType;
  entityId?: number;
  userId?: number;
  action?: AuditAction;
  from?: string;
  to?: string;
  page?: number;
  size?: number;
}

export const AUDIT_ENTITY_LABELS: Record<AuditEntityType, string> = {
  RESULT: 'Výsledek',
  COMPETITION: 'Soutěž',
  TEAM: 'Družstvo',
  CATEGORY: 'Kategorie',
  DISCIPLINE: 'Disciplína',
  RECORDER: 'Zapisovatel',
  USER: 'Uživatel',
  AUTH: 'Přihlášení',
};

export const AUDIT_ACTION_LABELS: Record<AuditAction, string> = {
  CREATE: 'Vytvoření',
  UPDATE: 'Úprava',
  DELETE: 'Smazání',
  ASSIGN: 'Přiřazení',
  REVOKE: 'Odebrání',
  LOGIN_SUCCESS: 'Přihlášení',
  LOGIN_FAIL: 'Neúspěšné přihlášení',
  LOGOUT: 'Odhlášení',
  PASSWORD_CHANGE: 'Změna hesla',
  PASSWORD_RESET: 'Reset hesla',
};
